import styled from "styled-components"

export const Wrapper = styled.div`
  width: 90%;
  margin: 0 auto;
  background-color: #fff;
  padding: 50px 40px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;

  .about_me {
    display: grid;
    margin-bottom: 50px;
  }

  .gatsby-image-wrapper {
    margin: 0 auto 20px auto;
    width: 250px;
  }

  .description h2,
  .gallery_container h2 {
    margin-bottom: 30px;
    font-weight: bold;
    font-size: 24px;
    line-height: 28px;
    color: #777d71;
  }

  .description p {
    margin-bottom: 10px;
    font-size: 0.7rem;
    line-height: 1rem;
    letter-spacing: 0.1em;
  }

  .gallery {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  .gallery img {
    margin: 10px;
  }

  @media (min-width: 900px) {
    #about_container {
      padding: 50px;
    }

    .about_me {
      grid-template-columns: 1fr 2fr;
      align-items: center;
    }

    .description {
      padding: 20px;
    }

    .profile_picture {
      border-radius: 0;
      width: 276px;
      height: auto;
      margin: 0 20px 0 0;
    }

    .gatsby-image-wrapper {
      width: 100%;
      height: 100%;
    }
  }

  @media (max-width: 700px) {
    width: 80%;

    .gatsby-image-wrapper {
      margin: 0 auto 20px auto;
      width: 100%;
    }
  }
`
